import { Box, Modal } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import axios from "../../util/axios";
import { Context } from "../Context/ErrorContext";
import { AgGridReact } from "ag-grid-react";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
interface UserReferModalProps {
  open: boolean;
  onClose?: () => void;
  getDashBoardData?: (id?: any) => void;
  user?: any;
}
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 800,
  width: "100%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  display: "flex",
  flexDirection: "column",
  gap: 2,
  borderRadius: "10px",
};

const UserReferModal = ({
  open,
  onClose,
  user,
  getDashBoardData,
}: UserReferModalProps) => {
  const { setError } = useContext(Context);
  const [userData, setUserData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchBy, setSearchBy] = useState("firstname");
  const [searchByText, setSearchByText] = useState("");
  const [referId, setReferId] = useState(0);

  const [colDefs] = useState<any>([
    {
      field: "fullname",
      headerName: "Name",
      minWidth: 250,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center gap-2 cursor-pointer"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 200,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-start"}>
            <p>{param.value}</p>
          </div>
        );
      },
    },
    { field: "phone", headerName: "Phone", minWidth: 150 },
    {
      field: "Refer",
      headerName: "refer",
      minWidth: 80,
      cellRenderer: (param: any) => {
        return (
          <div className={"flex items-center justify-center"}>
            <button
              className={
                "bg-primary flex items-center justify-center text-white rounded w-full max-h-[30px] p-0"
              }
              disabled={referId === param.data.id}
              onClick={() => handleRefer(param.data.id)}
            >
              Refer
            </button>
          </div>
        );
      },
    },
  ]);

  const onPageChange = (action: string, step: number) => {
    if (action === "prev") {
      if (pageNumber - step > 0) {
        setPageNumber(pageNumber - step);
      } else {
        setPageNumber(1);
      }
    } else {
      const totalPages = Math.ceil(totalRecords / pageSize);
      if (pageNumber + step <= totalPages) {
        setPageNumber(pageNumber + step);
      } else {
        setPageNumber(totalPages);
      }
    }
  };

  useEffect(() => {
    fetchData(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, pageSize]);

  const fetchData = async (text?: string) => {
    setLoading(true);
    const url =
      searchBy && text
        ? `/omw/users?page_num=${pageNumber}&page_size=${pageSize}&${searchBy}=${text}`
        : `/omw/users?page_num=${pageNumber}&page_size=${pageSize}`;
    axios({
      URL: url,
      method: "GET",
    })
      .then((res: any) => {
        if (res.data) {
          setUserData(res.data.data.users);
          setTotalRecords(res.data.data.total);
        }
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };


  const handleRefer = (id?: any) => {
    setLoading(true);
    axios({
      URL: `/omw/admin/manual-referral`,
      method: "POST",
      data: {
        fromId: user.id,
        toId: id,
      },
    })
      .then((res: any) => {
        if (res.data) {
          if (getDashBoardData) {
            getDashBoardData();
          }
        }
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <div className={"text-2xl font-bold"}>User Refer</div>

        <div className={"flex w-full justify-end my-3 px-3"}>
          <div
            className={
              "gap-2 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 md:w-auto w-full"
            }
          >
            <div className={"flex gap-1 justify-center items-center w-full"}>
              <label
                htmlFor="search"
                className={"text-primary whitespace-nowrap"}
              >
                Search By
              </label>
              <select
                name="search"
                id="search"
                className={`border border-primary text-primary border-solid py-2 w-full rounded-md`}
                value={searchBy}
                onChange={(e) => {
                  setSearchBy(e.target.value);
                }}
              >
                <option value={"firstname"}>First Name</option>
                <option value={"email"}>Email</option>
                <option value={"phone"}>Phone</option>
                <option value={"referral_code"}>Referral Code</option>
              </select>
            </div>
            <input
              className={
                "border border-primary border-solid p-2 text-primary placeholder-primary w-full rounded-md"
              }
              placeholder={"Search Driver"}
              value={searchByText}
              onChange={(e) => setSearchByText(e.target.value)}
            />
            <div className={"flex flex-row gap-2"}>
              <button
                className={
                  "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full h-[43px] disabled:cursor-not-allowed"
                }
                onClick={() => (searchBy ? fetchData(searchByText) : null)}
                disabled={loading}
              >
                Search
              </button>
              <button
                className={
                  "flex items-center justify-center bg-primary text-white px-8 py-2 rounded-md sm:w-auto w-full h-[43px] whitespace-nowrap disabled:cursor-not-allowed"
                }
                onClick={() => {
                  setSearchByText("");
                  setSearchBy("");
                  setPageNumber(1);
                  fetchData();
                }}
                disabled={loading}
              >
                Clear All
              </button>
            </div>
          </div>
        </div>
        <div className="ag-theme-quartz w-full" style={{ height: 500 }}>
          <AgGridReact
            loading={loading}
            rowData={userData}
            defaultColDef={{
              flex: 10,
            }}
            columnDefs={colDefs}
            suppressRowClickSelection={true}
          />
        </div>
        <div
          className={
            "my-2 px-2 w-full flex justify-end flex-col sm:flex-row gap-4 sm:gap-10"
          }
        >
          <div>
            <label htmlFor="pages">Page size:</label>
            <select
              name="page"
              id="page"
              className={
                "w-[100px] border-b border-primary border-solid p-2 outline-none"
              }
              value={pageSize}
              onChange={(e) => {
                setPageNumber(1);
                setPageSize(+e.target.value);
              }}
            >
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
          </div>
          <div className={"flex gap-2 justify-center items-center"}>
            <KeyboardDoubleArrowLeftIcon
              className={"text-lg cursor-pointer"}
              onClick={() => (pageNumber < 2 ? null : onPageChange("prev", 2))}
            />
            <KeyboardArrowLeftIcon
              className={"text-lg cursor-pointer"}
              onClick={() =>
                pageNumber === 0 ? null : onPageChange("prev", 1)
              }
            />
            <p>
              Page {pageNumber} of {Math.ceil(totalRecords / pageSize)}
            </p>
            <KeyboardArrowRightIcon
              className={`text-lg cursor-pointer`}
              onClick={() =>
                pageNumber === Math.ceil(totalRecords / pageSize)
                  ? null
                  : onPageChange("next", 1)
              }
            />
            <KeyboardDoubleArrowRightIcon
              className={"text-lg cursor-pointer"}
              onClick={() =>
                pageNumber + 2 > Math.ceil(totalRecords / pageSize)
                  ? null
                  : onPageChange("next", 2)
              }
            />
          </div>
        </div>
      </Box>
    </Modal>
  );
};
export default UserReferModal;
